import axios from 'axios';
import { resolveApiUrl } from '../utils/api';

export interface Coordinate {
  lat: number;
  lng: number;
}

export interface RoadToolGeometry {
  centerlines?: GeoJSON.FeatureCollection;
  lane_boundaries?: GeoJSON.FeatureCollection;
  road_edges?: GeoJSON.FeatureCollection;
  road_surface?: GeoJSON.FeatureCollection;
  intersections?: GeoJSON.FeatureCollection;
  metadata?: {
    radius_m: number;
    roads_detected: number;
    lane_boundaries_count: number;
    road_edges_count: number;
    road_surfaces_count?: number;
    intersections_count: number;
  };
}

/**
 * Generate road tool geometry from OSM data for a workzone.
 * 
 * @param workzonePolygon Array of coordinates defining the workzone
 * @param radiusM Radius in meters to search for roads (default 500m)
 * @returns Road tool geometry with centerlines, lane boundaries, road edges, and intersections
 */
export async function generateRoadTool(
  workzonePolygon: Coordinate[],
  radiusM: number = 500, 
  state: string
): Promise<RoadToolGeometry> {
  try {
    const response = await axios.post(
      resolveApiUrl('/api/road-tool/generate'),
      {
        workzone: {
          polygon: workzonePolygon
        },
        radius_m: radiusM,
        state: state
      }
    );
    
    return response.data;
  } catch (error: any) {
    console.error('Error generating road tool:', error);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.details || 
      'Failed to generate road tool geometry'
    );
  }
}

/**
 * Update road tool geometry (for future use when editing is implemented).
 * 
 * @param geometry Updated road tool geometry
 */
export async function updateRoadTool(
  geometry: RoadToolGeometry
): Promise<void> {
  // TODO: Implement when backend supports saving user edits
  throw new Error('Road tool editing persistence not yet implemented');
}


